(function () {
  function init() {
    var list = document.querySelector(".qr-faq__list");
    if (!list || list.dataset.qrInit) return;
    list.dataset.qrInit = "true";

    var items = list.querySelectorAll(".qr-faq-item");
    items.forEach(function (item) {
      var btn = item.querySelector("[data-qr-faq-toggle]");
      btn.addEventListener("click", function () {
        var wasOpen = item.classList.contains("is-open");
        items.forEach(function (other) {
          other.classList.remove("is-open");
          other.querySelector("[data-qr-faq-toggle]").setAttribute("aria-expanded", "false");
        });
        if (!wasOpen) {
          item.classList.add("is-open");
          btn.setAttribute("aria-expanded", "true");
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
